/**
 * UpgradablePlanContainer component.
 */
import Direction from '@shared/types/enums/direction';
import styled from 'styled-components';

/**
 * Styled upgradable plan container.
 */
const UpgradablePlanContainer = styled.div.attrs({
  id: 'upgradablePlanContainer',
})<{ direction?: Direction }>`
  display: flex;
  flex-direction: ${(props) =>
    props.direction === Direction.VERTICAL ? 'column' : 'row'};
`;

export default UpgradablePlanContainer;
